import { useEffect } from 'react'

import {
  SmsConsentStatusOption,
  fetchSmsConsentStatus,
  getSmsConsentStatus,
} from './smsConsentReducer'
import { useReselector } from '@/utils/sharedHooks'
import { useAppDispatch } from '@/utils/typeHelpers'

import { Heading, HeadingVariants } from '@/ui'
import { OptedIn } from './OptedIn'
import { OptedOut } from './OptedOut'

export const SmsConsent = () => {
  const dispatch = useAppDispatch()
  const smsConsentStatus = useReselector(getSmsConsentStatus)

  useEffect(() => {
    dispatch(fetchSmsConsentStatus())
  }, [dispatch])

  const isOptedIntoSms =
    smsConsentStatus?.status === SmsConsentStatusOption.OPT_IN

  return (
    <div className="flex flex-col mb-4 gap-2">
      <Heading variant={HeadingVariants.H2}>SMS Consent</Heading>

      {isOptedIntoSms && smsConsentStatus ? (
        <OptedIn
          createdAt={smsConsentStatus.createdAt}
          mobilePhoneNumber={smsConsentStatus.mobilePhoneNumber}
        />
      ) : (
        <OptedOut />
      )}
    </div>
  )
}
